import React from 'react';
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';


export const ModalViewList = ({ showModal, handleModal, contentModal, title, type, icon, isLoading = false }) => {

    const loader = <div className="d-flex justify-content-center align-content-end mt-5">
        <Spinner color="primary" style={{ height: '3rem', width: '3rem' }} />
    </div>
    
    return (
        <>
            <Modal isOpen={showModal} toggle={handleModal} size='sm' className={`w-100 modal-dialog-summary float-right ${type}`}>
                <ModalHeader toggle={handleModal} className='pb-0'></ModalHeader>
                <ModalBody className='pt-2'>
                    <div className='d-flex align-items-center mb-3'>
                        <div className='mb-0 mr-3'><img src={icon} width={60} height={60} alt={title}/></div>
                        <h2 className='libre-caslon-text-regular text-capitalize mb-0 h4'>{title}</h2>
                    </div>
                    <p>Tap a member to view their profile</p>

                    {!isLoading 
                        ? contentModal
                        : loader
                    }
                </ModalBody>
            </Modal>
        </>
    )
}
